import { useState, useEffect } from 'react';
import { getWeatherEmoji } from '../utils';

const Clock = ({ timezone, city, lat, lng }) => {
  const [time, setTime] = useState(new Date());
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!lat || !lng) return;

    const fetchWeather = async () => {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,weather_code&temperature_unit=fahrenheit`;
        const resp = await fetch(url);
        const data = await resp.json();
        if (data.current) {
          setWeather({
            temp: Math.round(data.current.temperature_2m),
            emoji: getWeatherEmoji(data.current.weather_code),
          });
        }
      } catch (e) {
        console.error('[Clock] Error fetching weather:', e);
      }
    };

    fetchWeather();
    const weatherTimer = setInterval(fetchWeather, 600000); // Update every 10 mins
    return () => clearInterval(weatherTimer);
  }, [lat, lng]);

  const getTzAbbr = (date, tz) => {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZoneName: 'short',
        timeZone: tz || undefined,
      }).formatToParts(date);
      return parts.find((p) => p.type === 'timeZoneName')?.value || '';
    } catch (e) {
      return '';
    }
  };

  const tzAbbr = getTzAbbr(time, timezone);
  const cityName = city ? city.split(',')[0].toUpperCase() : '';

  const timeStr = time.toLocaleTimeString('en-US', {
    timeZone: timezone,
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
  });
  const dayStr = time.toLocaleDateString('en-US', {
    timeZone: timezone,
    weekday: 'short',
  });
  const dateStr = time.toLocaleDateString('en-US', {
    timeZone: timezone,
    month: 'numeric',
    day: 'numeric',
  });

  return (
    <div className="flex flex-col items-end leading-none ml-4 mr-1 select-none">
      <div className="flex items-center gap-2">
        <span className="text-[26px] font-black text-zinc-900 tracking-tighter">
          {timeStr}
        </span>
        {weather && (
          <div className="flex items-center gap-1">
            <span className="text-[16px]">{weather.emoji}</span>
            <span className="text-[14px] font-black text-zinc-400 tabular-nums">
              {weather.temp}°
            </span>
          </div>
        )}
      </div>
      <div className="flex items-center gap-1.5 mt-[-1px]">
        {cityName && (
          <div className="flex items-center gap-1">
            <span className="text-[10px] font-black text-zinc-500 tracking-tighter truncate max-w-[60px]">
              {cityName}
            </span>
            <span className="text-[9px] font-bold text-zinc-400 uppercase tracking-widest">
              {tzAbbr}
            </span>
          </div>
        )}
        <span className="text-[14px] font-bold text-zinc-400 tabular-nums uppercase tracking-tight">
          {dayStr} {dateStr}
        </span>
      </div>
    </div>
  );
};

export default Clock;
